import React from "react";
import { Row, Col } from "reactstrap";
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { UserSearchAutocomplete } from '../../../../shared/UserSearchAutocomplete';
import { ListUsers } from "./usersInGroupTable/ListUsers";
import { ACL } from '../../../../../config/constants';


function GroupUsersTab(props) {
  const {
    usersInGroup,
    usersNotInGroup,
    updateGroupWithUser
  } = props;

  const addUser = (user) => {
    if (! ACL.ADMIN.GROUPS.SYNC_USERS.hasAccess()) {
      return;
    }

    let users = [ ...usersInGroup ];
    users.push( user );
    updateGroupWithUser( users, user, 'add' );
  }

  const removeUser = (user) => {
    if (! ACL.ADMIN.GROUPS.SYNC_USERS.hasAccess()) {
      return;
    }

    let users = usersInGroup.filter( (element) => element.id !== user.id );
    updateGroupWithUser( users, user, '' );
  }

  return (
    <div className="admin-group-detail-section admin-group-detail-section--users">
          {ACL.ADMIN.GROUPS.SYNC_USERS.hasAccess() &&
          <Row className="admin-group-detail-user-search justify-content-center align-items-center p-3">
            <FontAwesomeIcon size="lg" className="ml-2" icon={faSearch}/>
            <Col className="text-center">
              <UserSearchAutocomplete
                data={usersNotInGroup ? usersNotInGroup : []}
                onSelect={addUser}
              />
            </Col>
          </Row>}
          <div className="admin-group-detail-users-list">
            <ListUsers users={usersInGroup} removeUser={removeUser}/>
          </div>
    </div>
  );
}

export { GroupUsersTab }
